import type { FeaturedViewModel } from '@/wabunka-src/common/features';

/**
 * microCMSから返ってくる特集ページの記事情報の中にある体験のIDを抽出する
 */
export const useExtractExperienceIds = (featuredFromCMS: Ref<FeaturedViewModel>) => {
  const articleSections = featuredFromCMS.value.contents
    .filter((section) => section?.fieldId === 'articleSection')
    .flatMap((content) => {
      if (content.fieldId === 'articleSection') {
        return content.columns?.flatMap((column) => column.contents);
      }

      return [];
    });

  const articleColumnItineraryParts = articleSections.flatMap((section) => (section.fieldId === 'itineraryParts' ? section.itineraryParts : []));

  const experienceIds = [...articleSections, ...articleColumnItineraryParts]
    .flatMap((content) => {
      const { fieldId } = content;

      if (fieldId === 'smallExps' || fieldId === 'mediumExps') {
        return content.experiences.map((experience) => experience.id);
      }
      if (fieldId === 'largeExps' && content.experience?.id) {
        return [content.experience.id];
      }

      return [];
    })
    .flat();

  const uniqueExperienceIds = [...new Set(experienceIds)];

  return { experienceIds: ref(uniqueExperienceIds) };
};
